import React, {
  createContext,
  useEffect,
  useState,
  useCallback,
  useMemo,
} from "react";
import { exhibitionFetcher } from "../api/requests";

const ExhibitionContext = createContext();

const ExhibitionContextProvider = ({ children }) => {
  const [exhibitions, setExhibitions] = useState({});
  const [isLoadingExhibitions, setIsLoadingExhibitions] = useState(false);
  const [floors, setFloors] = useState({});
  const [isLoadingFloors, setIsLoadingFloors] = useState(false);
  const [stores, setStores] = useState({});
  const [isLoadingStores, setIsLoadingStores] = useState(false);

  const updateExhibitions = useCallback((newData) => {
    setExhibitions(newData);
  }, []);

  const updateFloors = useCallback((newData) => {
    setFloors(newData);
  }, []);

  const updateStores = useCallback((newData) => {
    setStores(newData);
  }, []);

  const getExhibitions = useCallback(async () => {
    setIsLoadingExhibitions(true);
    try {
      setExhibitions(await exhibitionFetcher.getExhibition());
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoadingExhibitions(false);
    }
  }, []);

  const getFloors = useCallback(async () => {
    setIsLoadingFloors(true);
    try {
      setFloors(await exhibitionFetcher.getFloor());
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoadingFloors(false);
    }
  }, []);

  const getStores = useCallback(async () => {
    setIsLoadingStores(true);
    try {
      setStores(await exhibitionFetcher.getStore());
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoadingStores(false);
    }
  }, []);

  useEffect(() => {
    getExhibitions();
    getFloors();
    getStores();
  }, [getExhibitions, getFloors, getStores]);

  const contextValue = useMemo(
    () => ({
      exhibitions,
      updateExhibitions,
      getExhibitions,
      isLoadingExhibitions,
      floors,
      updateFloors,
      isLoadingFloors,
      stores,
      updateStores,
      isLoadingStores,
    }),
    [
      exhibitions,
      floors,
      stores,
      isLoadingExhibitions,
      isLoadingFloors,
      isLoadingStores,
    ]
  );

  return (
    <ExhibitionContext.Provider value={contextValue}>
      {children}
    </ExhibitionContext.Provider>
  );
};

export { ExhibitionContext, ExhibitionContextProvider };
